import React, { Component } from 'react'
import Field from '../Field/Field.jsx'
// TODO: UiIcon
import Icon from '../../common/components/Icon'

class PasswordField extends Component {

	constructor(props) {
		super(props);

		this.state = {
			isVisible: false,
		}

		this.toogleIsVisible = this.toogleIsVisible.bind(this)
	}

	render() {
		const { isVisible } = this.state

		const icon = isVisible
			? 'visibility'
			: 'visibility-off'

		const type = isVisible
			? 'text'
			: 'password'

		return (
			<div className="password-field">
				<Field type={type} {...this.props} ref={elem => this.field = elem} />
				<div className="password-field__icon" onClick={this.toogleIsVisible}>
					<Icon icon={icon} />
				</div>
			</div>
		)
	}

	toogleIsVisible() {
		const { isVisible } = this.state
		this.setState({ isVisible: !isVisible })
	}
}

export default PasswordField



// WEBPACK FOOTER //
// ./src/js/Ui/PasswordField/PasswordField.jsx